/* jshint esversion: 6 */
import RouteView from "@/views/common/views/RouteView";
// import { device } from "@/utils";

// 将需要动态注册的路由提取到vuex中
export default [
  // 诊断服务(综合服务机构)
  {
    path: "/diagnose",
    name: "diagnose",
    title: "诊断服务-综合",
    sort: 3,
    redirect: "/diagnose/project-management",
    component: RouteView,
    meta: { title: "诊断服务-综合", icon: "ios-keypad" },
    children: [
      {
        path: "/diagnose/project-management",
        component: () => import("@/views/pc/diagnose/projectManagement"),
        name: "project-management",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "项目管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          {
            path: "/diagnose/project-management/:action(add)",
            component: () => import("@/views/pc/diagnose/projectManagement/edit"),
            name: "ProjectManagementAdd",
            hidden: true,
            meta: {
              title: "新增项目",
              keepAlive: false,
            },
          },
          {
            name: "project_management_delete",
            meta: {
              title: "删除项目",
              perms: "sys:projectManagement:delete",
            },
          },
          {
            path: "/diagnose/project-management/:action(edit|show)/:id",
            component: () => import("@/views/pc/diagnose/projectManagement/edit"),
            name: "ProjectManagementEidt",
            hidden: true,
            meta: {
              title: "编辑项目",
              keepAlive: false,
            },
          },
          {
            path: "/diagnose/project-management/:action(list)/:id",
            component: () => import("@/views/pc/diagnose/projectManagement/list"),
            name: "ProjectManagementEnterpriseList",
            hidden: true,
            meta: {
              title: "企业列表",
              keepAlive: false,
            },
          },
        ],
      },
      {
        path: "/diagnose/track",
        component: () => import("@/views/pc/diagnose/track"),
        name: "track",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "进展跟踪",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          {
            name: "sys_track_upload",
            meta: {
              title: "上传附件",
              perms: "sys:track:upload",
            },
          },
          {
            name: "sys_track_update",
            meta: {
              title: "修改日期",
              perms: "sys:track:update",
            },
          },
          {
            name: "sys_track_deleted",
            meta: {
              title: "删除附件",
              perms: "sys:track:deleted",
            },
          },
          {
            name: "sys_track_audit",
            meta: {
              title: "审核服务",
              perms: "sys:track:audit",
            },
          },
          {
            name: "sys_track_regression",
            meta: {
              title: "退回服务",
              perms: "sys:track:regression",
            },
          },
        ],
      },
      {
        path: "/diagnose/appointment",
        component: () => import("@/views/pc/diagnose/appointment"),
        name: "diagnose-appointment",
        sort: 2,
        hideChildrenInMenu: true,
        meta: {
          title: "预约管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [],
      },
      {
        path: "/diagnose/service-company",
        component: () => import("@/views/pc/diagnose/serviceCompany"),
        name: "service-company",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "服务商管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          {
            path: "/diagnose/service-company/:action(aprv|edit|copy|show)/:id",
            name: "members",
            sort: 1,
            component: () => import("@/views/pc/diagnose/serviceCompany"),
            meta: {
              title: "成员",
            },
          },
        ],
      },
      {
        path: "/diagnose/target-company",
        component: () => import("@/views/pc/diagnose/targetCompany"),
        name: "target-company",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "企业管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [],
      },
      // {
      //   path: "/diagnose/self",
      //   component: () => import("@/views/pc/diagnose/self"),
      //   name: "self",
      //   sort: 1,
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: "企业自评",
      //     hiddenHeaderTitle: true,
      //     icon: "md-list-box",
      //   },
      //   children: [],
      // },
      {
        path: "/diagnose/childrenAccount",
        component: () => import("@/views/pc/diagnose/childrenAccount"),
        name: "diagnose-childrenAccount",
        sort: 4,
        hideChildrenInMenu: true,
        meta: {
          title: "子账号管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [],
      },
    ],
  },
];
